import { Col, Container, Row, Card, Button } from 'react-bootstrap';
import '../style/footer.css';

const Footer = () => {
  return (
    <div>
      <footer className="footer bg-transparent text-center">
        <div className="footer-content">
          <div className="contact-info d-flex">
            <p>&copy; {new Date().getFullYear()} Yehezkiel David Setiawan. All rights reserved.</p>
            <div className="social-icons text-center">
              <a className="brand" href="https://www.instagram.com/syntax._error" target="_blank" rel="noopener noreferrer">
                <i className="fa-brands fa-instagram fa-2xl"></i>
              </a>
              <a className="brand" href="mailto:yehezkieldavid2006@gmail.com">
                <i className="fa-regular fa-envelope fa-2xl"></i>
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
